module.exports = __webpack_public_path__ + "static/media/harlowsi-webfont.e32d1b58.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/font/harlowsi-webfont.woff2
// module id = 1103
// module chunks = 0